import { render, staticRenderFns } from "./ResourcePhotoPreview.vue?vue&type=template&id=60160816&scoped=true&"
import script from "./ResourcePhotoPreview.vue?vue&type=script&lang=ts&"
export * from "./ResourcePhotoPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcePhotoPreview.vue?vue&type=style&index=0&id=60160816&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60160816",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60160816')) {
      api.createRecord('60160816', component.options)
    } else {
      api.reload('60160816', component.options)
    }
    module.hot.accept("./ResourcePhotoPreview.vue?vue&type=template&id=60160816&scoped=true&", function () {
      api.rerender('60160816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/resource-details/ResourcePhotoPreview.vue"
export default component.exports